/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { Tooltip } from 'bootstrap'
import $ from 'jquery'

import { disposeTooltip } from '@/js/utils/bootstrap'

/**
 * Initialize a Select2 widget on each visible `select.form-select`. Destroys
 * it on disconnect.
 *
 * @type {Listener}
 */
export default {
    selector: 'select.form-select:not(.hidden)',
    connect(element) {
        const $select = $(element)

        let template
        if ($select.data('template-description')) {
            template = (state) => {
                if (!state.id) {
                    return state.text
                }

                return $('<span>').append(`${state.text}<br /><small>${$(state.element).data('description')}</small>`)
            }
        }

        const select2options = {
            templateResult: template,
            placeholder: $select.attr('title'),
            dropdownCssClass: $select.hasClass('hide-disabled-options') ? 'hide-disabled-options' : '',
            theme: 'bootstrap-5',
            // Opt-in override via data-minimum-results-for-search (e.g. 0 to always show the search).
            minimumResultsForSearch: $select.data('minimumResultsForSearch') ?? 10,
            width: $select.data('width') ? $select.data('width') : $select.hasClass('w-100') ? '100%' : 'style',
        }

        // Bootstrap's modal focus trap blocks focus on elements outside the modal:
        // attach the dropdown inside it so the search field stays focusable.
        const modal = element.closest('.modal')
        if (modal) {
            select2options.dropdownParent = $(modal)
        }

        const autocompleteUrl = $select.data('autocompleteUrl')
        if (undefined !== autocompleteUrl) {
            select2options.allowClear = !element.hasAttribute('required')
            if (select2options.allowClear) {
                const placeholder = $select.data('placeholder')
                if (undefined !== placeholder) {
                    select2options.placeholder = placeholder
                }
            }
            select2options.ajax = {
                url: autocompleteUrl,
                dataType: 'json',
                delay: 250,
                data({ term, page }) {
                    return { query: term, page }
                },
                cache: true,
            }
        }

        $select.select2(select2options).on('refresh.mmsSelect', () => {
            $select.trigger('change.select2')
        })

        let $tooltipTarget = null
        if ($select.data('bsToggle') === 'tooltip') {
            $tooltipTarget = $select.siblings('.select2-container')
            $tooltipTarget.tooltip({
                title: $select.attr('title'),
                placement: $select.data('placement'),
            })
        }

        return () => {
            if ($tooltipTarget?.length) {
                disposeTooltip(Tooltip.getInstance($tooltipTarget[0]))
            }
            $select.off('.mmsSelect')
            $select.select2('destroy')
        }
    },
}
